import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import AboutBanner from "../components/about/AboutBanner";
import AboutStats from "../components/about/AboutStats";
import Beliefs from "../components/about/Beliefs";
import Team from "../components/about/Team";

export default function About() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="About Kudosta" title="A product-minded software studio for businesses that outgrew the template.">
                    We're a compact, senior team of engineers, designers and strategists. We've spent nine years building custom software that quietly runs businesses across six countries.
                </PageHero>

                {/* <AboutBanner /> */}

                <AboutStats />

                <Beliefs />

                <Team />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
